import { Observable, Subject } from "rxjs";

import { Injectable } from "@angular/core";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { BFXLogoutWarningService } from "../bfx-common/services/bfx-logout-warnings.service";

@Injectable()
export class LogoutNotificationService {
  private logoutSubject: Subject<any>;
  private logoutCompleteSubject: Subject<any>;
  private logoutNotificationSubjects = new Map<any, any>();
  private logoutObservableMap = new WeakMap<any, any>();

  private nextLogoutNotificationSubjects = new Map<any, any>();
  private next = false;

  constructor(private logoutWarningService: BFXLogoutWarningService) {
    this.logoutSubject = new Subject<Promise<boolean>>();
    this.logoutCompleteSubject = new Subject<Promise<boolean>>();

    this.logoutSubject.subscribe(() => {
      this.next = true;
      for (let v of this.logoutNotificationSubjects.values()) {
        v.s.next({ res: v.res, rej: v.rej });
      }

      Promise.all(Array.from(this.logoutNotificationSubjects.keys())).then(
        (logoutAccepted: boolean[]) => {
          if (
            Array.isArray(logoutAccepted) &&
            (logoutAccepted.length === 0 || logoutAccepted.every((v) => v === true))
          ) {
            this.logoutCompleteSubject.next(true);

            for (let v of this.logoutNotificationSubjects.values()) {
              v.s.complete();
            }
          } else {
            this.logoutCompleteSubject.next(false);
            this.logoutNotificationSubjects.clear();
            this.logoutNotificationSubjects = new Map(this.nextLogoutNotificationSubjects);
            this.nextLogoutNotificationSubjects.clear();
            this.next = false;
          }
        },
        (error) => {
          this.logoutNotificationSubjects.clear();
          this.logoutNotificationSubjects = new Map(this.nextLogoutNotificationSubjects);
          this.nextLogoutNotificationSubjects.clear();
          this.next = false;

          logger.out.warn(`${this.constructor.name}: error requesting logout`);
          this.logoutCompleteSubject.error(error);
        },
      );
    });
  }

  public requestLogout() {
    this.logoutWarningService.warnOnLogout(this.onLogoutConfirm.bind(this));
    return this.logoutCompleteSubject.asObservable();
  }

  private onLogoutConfirm() {
    this.logoutSubject.next(true);
  }

  public getLogoutNotification(): Observable<any> {
    let v = { s: new Subject(), res: null, rej: null };
    let p = new Promise<boolean>((res, rej) => {
      v.res = res;
      v.rej = rej;
    });
    let o = v.s.asObservable();

    if (this.next) {
      this.nextLogoutNotificationSubjects.set(p, v);
    } else {
      this.logoutNotificationSubjects.set(p, v);
    }
    this.logoutObservableMap.set(o, p);
    return o;
  }

  public deregisterLogoutNotification(o: Observable<any>) {
    let p = this.logoutObservableMap.get(o);

    if (p != null) {
      if (this.logoutNotificationSubjects.has(p)) {
        let v = this.logoutNotificationSubjects.get(p);

        // a de registration counts as a close
        v.res(true);
        v.s.complete();
        this.logoutNotificationSubjects.delete(p);
      }
    }
  }
}
